import { render } from "./client-feedback.vue?vue&type=template&id=b437d7f4"
import script from "./client-feedback.vue?vue&type=script&lang=js"
export * from "./client-feedback.vue?vue&type=script&lang=js"

import "./client-feedback.vue?vue&type=style&index=0&id=b437d7f4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__